import React from "react";
import CategoryPage from "./CategoryPage";

function Photos({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Photos"
      parentCategory="Media"
      parentCategoryValues={[
        "Photos & Videos",
        "PhotosVideos",
        "Media"
      ]}
      posts={posts}
      publications={publications}
    />
  );

}

export default Photos;